
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, LayoutDashboard, Music, LogIn, MessageCircle } from 'lucide-react';

interface DesktopNavigationProps {
  isAuthenticated: boolean;
  onSignOut: () => void;
}

const DesktopNavigation: React.FC<DesktopNavigationProps> = ({ isAuthenticated, onSignOut }) => {
  // Function to scroll to top on navigation
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <nav className="hidden lg:flex items-center gap-6">
      <div className="flex items-center gap-6">
        <Link to="/" onClick={scrollToTop} className="text-foreground text-sm hover:text-primary transition-colors flex items-center gap-2 py-2 w-[90px] justify-center">
          <Home size={18} />
          <span>Home</span>
        </Link>
        
        {isAuthenticated && (
          <>
            <Link to="/dashboard" onClick={scrollToTop} className="text-foreground text-sm hover:text-primary transition-colors flex items-center gap-2 py-2 w-[120px] justify-center">
              <LayoutDashboard size={18} />
              <span>Dashboard</span>
            </Link>
            <Link to="/tracks" onClick={scrollToTop} className="text-foreground text-sm hover:text-primary transition-colors flex items-center gap-2 py-2 w-[90px] justify-center">
              <Music size={18} />
              <span>Tracks</span>
            </Link>
          </>
        )}
        
        <Link to="/contact" onClick={scrollToTop} className="text-foreground text-sm hover:text-primary transition-colors flex items-center gap-2 py-2 w-[90px] justify-center">
          <MessageCircle size={18} />
          <span>Contact</span>
        </Link>
      </div>
      
      <div className="flex items-center gap-6">
        {isAuthenticated ? (
          <Button 
            variant="outline" 
            onClick={onSignOut}
            className="w-[100px] text-sm"
          >
            Sign Out
          </Button>
        ) : (
          <>
            <Link to="/login" onClick={scrollToTop} className="text-foreground text-sm hover:text-primary transition-colors flex items-center gap-2 py-2 w-[90px] justify-center">
              <LogIn size={18} />
              <span>Sign In</span>
            </Link>
            <Link to="/register" onClick={scrollToTop}>
              <Button className="w-[160px] text-sm">Start My FREE Trial</Button>
            </Link>
          </>
        )}
      </div>
    </nav>
  );
};

export default DesktopNavigation;
